import RoomComposer from './RoomComposer';

export default RoomComposer;
